module.exports = new __parcel__URL__("addimage.f941c079.png").toString();